import { useEffect, useRef } from 'react';
import useIsInstagramBrowser from './useIsInstagramBrowser';
import {
  buildSearchWithoutExternalBrowserRedirect,
  buildVisitUrlFromExternalBrowserRedirect,
  getDecodedExternalBrowserRedirectUrl,
  getExternalBrowserRedirectSearchValue,
  stripExternalBrowserRedirectFromUrl,
} from '../lib/external-browser';
import { markOutboundLinkOpened } from '../lib/outbound-link';

const useRedirectFromExternalBrowser = (disableDeeplinks = false) => {
  const isInstagramBrowser = useIsInstagramBrowser();
  const hasTriggeredRedirectRef = useRef(false);

  useEffect(() => {
    if (
      typeof window === 'undefined' ||
      isInstagramBrowser ||
      hasTriggeredRedirectRef.current
    ) {
      return;
    }

    const encodedRedirectUrl = getExternalBrowserRedirectSearchValue(
      window.location.search
    );
    if (!encodedRedirectUrl) {
      return;
    }

    const nextSearch = buildSearchWithoutExternalBrowserRedirect(
      window.location.search
    );
    const nextUrl = `${window.location.pathname}${nextSearch ? `?${nextSearch}` : ''}`;

    if (disableDeeplinks) {
      window.history.replaceState(null, '', nextUrl);
      return;
    }

    hasTriggeredRedirectRef.current = true;
    window.history.replaceState(null, '', nextUrl);

    const decodedRedirectUrl =
      getDecodedExternalBrowserRedirectUrl(encodedRedirectUrl);

    const destinationUrl = decodedRedirectUrl
      ? stripExternalBrowserRedirectFromUrl(decodedRedirectUrl)
      : buildVisitUrlFromExternalBrowserRedirect(encodedRedirectUrl);

    markOutboundLinkOpened(destinationUrl);

    setTimeout(() => {
      window.location.href = destinationUrl;
    }, 150);
  }, [disableDeeplinks, isInstagramBrowser]);
};

export default useRedirectFromExternalBrowser;
